import { createSlice } from '@reduxjs/toolkit';

export const meSlice = createSlice({
    name: 'me',
    initialState: {
        data: null,
    },
    reducers: {
        setUser: (state, {payload}) => {
            state.data = payload;
        }
    },
});

export const {
    setUser,
} = meSlice.actions;

export default meSlice.reducer;
